window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-users-setting');
    if (!page) return;

    $(function () {
        init();

        function init() {
            events();
        }

        function events() {
            $('#frm_setting').on('submit', function () {
                $(this).find('button[type="submit"]').prop('disabled', true);
            });
        }
    });
});
